import styled, { css } from 'styled-components'
import { CheckboxLabelProps, CheckmarkProps, CheckboxContainerProps } from './types'

export const CheckboxContainer = styled('div') <CheckboxContainerProps>`
  min-height: ${props => props.removeMargins ? 'initial' : '46px'};

  ${props => props.version === 2 && css`
    min-height: initial;
  `}
  
  ${props => props.marginWrapper && css`
    margin: ${props.marginWrapper || '0'};
  `}
`

export const CheckboxInput = styled.input`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const Checkmark = styled('span') <CheckmarkProps>`
  position: absolute;
  top: ${props => props.small ? '2px' : '0'};
  left: ${props => props.small ? '4px' : '0'};
  width: 24px;
  height: 24px;
  background-color: ${props => props.theme.colors.main.background};
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 9px;
    top: 3px;
  }

  ${props =>
    props.error &&
    css`
      border: 1px solid ${props => props.theme.colors.main.error};
    `}

  ${props => props.small &&
    css`
      transform: scale(0.6155);
    `}

  ${props => props.version === 2 && css`
    margin-top: 4px;
    height: 16px;
    width: 16px;

    &:after {
      left: 4px;
      top: 0;
    }
  `}
`

export const CheckboxLabel = styled('label') <CheckboxLabelProps>`
  height: ${props => props.labelHeight || '24px'};
  ${props => props.labelMinHeight && css`
    min-height: ${props.labelMinHeight};
  `}
  display: ${props => props.labelDisplay || 'flex'};
  ${props => !props.labelDisplay && css`
    align-content: center;
    align-items: center;
  `}
  position: relative;
  padding-left: 35px;
  padding-top: 3px;
  margin-bottom: ${props => props.removeMargins ? '2px' : '8px'};
  cursor: pointer;
  color: ${props => props.theme.colors.main.dark};
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  overflow: ${props => props.labelOverflow || 'hidden'};
  text-overflow: ellipsis;
  white-space: ${props => props.labelWhiteSpace || 'nowrap'};

  & ${CheckboxInput}:disabled ~ ${Checkmark} {
    background-color: ${props => props.theme.colors.shades.neutral[0]};
    pointer-events: none;
  }

  & ${CheckboxInput}:checked ~ ${Checkmark} {
    background-color: ${props => props.theme.colors.main.ultraViolet};
  }

  & ${CheckboxInput}:disabled:checked ~ ${Checkmark} {
    background-color: ${props => props.theme.colors.shades.neutral[1]};
    pointer-events: none;
  }

  & ${CheckboxInput}:checked ~ ${Checkmark}:after {
    display: block;
  }

  & ${Checkmark}:after {
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${props => props.version === 2 && css`
    padding-top: 2px;
    padding-left: 13px;
    margin-bottom: 0;
  `}

  ${props => props.bold && css`
    font-weight: ${props.bold ? 'bold' : 'initial'};
  `}
`

export const CheckboxErrorText = styled.h6`
  margin-block-start: 8px;
  margin-block-end: 0;
  color: ${props => props.theme.colors.main.error};
  font-size: 12px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
